import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../Configurations/AuthContext";
export default function Header({ currency, onCurrencyChange }) {
  const { user, logout } = useAuth();
  return (
    <header id="page-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
            {/* LOGO */}
            <div className="navbar-brand-box horizontal-logo">
              <Link className="logo fs-3">Accounting</Link>
            </div>
            <button
              type="button"
              className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
              id="topnav-hamburger-icon"
            ></button>
          </div>
          <div className="d-flex align-items-right">
            <div
              className="dropdown ms-sm-3 header-item gap-4 d-flex align-items-center"
              style={{ fontSize: "15px" }}
            >
              <Link
                to={"/dashboard"}
                className="nav-link menu-link"
                href="#dashboard"
              >
                <i className="ri-dashboard-line text-primary me-1"></i>{" "}
                <span data-key="t-hotels">Dashboard</span>
              </Link>
              <Link
                to={"/saleinvoice"}
                className="nav-link menu-link"
                href="#Invoice"
              >
                <i className="ri-file-list-3-line text-success me-1"></i>{" "}
                <span data-key="t-hotels">Sale</span>
              </Link>
              <Link
                to={"/purchaseinvoice"}
                className="nav-link menu-link"
                href="#Voucher"
              >
                <i className="ri-shopping-bag-3-line text-primary me-1"></i>{" "}
                <span data-key="t-hotels">Purchase</span>
              </Link>
              <Link
                to={"/expenseinvoice"}
                className="nav-link menu-link"
                href="#Expense"
              >
                <i className="ri-wallet-3-line text-danger me-1"></i>{" "}
                <span data-key="t-hotels">Expense</span>
              </Link>
              <Link
                to={"/customerReports"}
                className="nav-link menu-link"
                href="#Reports"
              >
                <i className="ri-pie-chart-line text-info me-1"></i>{" "}
                <span data-key="t-Packages">Reports</span>
              </Link>
              <Link
                to={"/journalreports"}
                className="nav-link menu-link"
                href="#settings"
              >
                <i class="ri-file-chart-line text-info me-1"></i>{" "}
                <span> Accounting Reports</span>
              </Link>
            </div>
          </div>

          <div className="dropdown ms-sm-3 header-item topbar-user">
            <button
              type="button"
              className="btn shadow-none"
              id="page-header-user-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="d-flex align-items-center">
                <span className="text-start ms-xl-2">
                  <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                    {user?.name}
                  </span>
                  <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                    Welcome
                  </span>
                </span>
              </span>
            </button>
            <div className="dropdown-menu dropdown-menu-end">
              {/* item*/}
              <h6 className="dropdown-header">Welcome!</h6>

              <Link
                to={"/industries"}
                className="dropdown-item"
                href="#masters"
              >
                <i class="ri-database-2-line text-secondary me-2"></i>{" "}
                <span>Masters</span>
              </Link>
              <Link
                to={"/customers"}
                className="dropdown-item"
                href="#settings"
              >
                <i class="ri-settings-5-line text-warning me-1"></i>{" "}
                <span> Account Settings</span>
              </Link>
              <Link
                to={"/companyprofile"}
                className="dropdown-item"
                href="#settings"
              >
                <i class="ri-user-settings-line text-primary me-1"></i>

                <span> Profile Settings</span>
              </Link>
              <Link className="dropdown-item" onClick={logout}>
                <i class="ri-logout-box-r-line text-danger me-1"></i>{" "}
                <span className="align-middle" data-key="t-logout">
                  Logout
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
